import { AlertCircle, AlertTriangle, Info } from 'lucide-react';

import { cn } from '@/lib/utils';

interface AuthErrorProps {
  message: string;
  variant?: 'error' | 'warning' | 'info';
}

export function AuthError({ message, variant = 'error' }: AuthErrorProps) {
  const variants = {
    error: {
      containerClass: 'bg-red-50 text-red-900',
      iconClass: 'text-red-400',
      Icon: AlertCircle,
    },
    warning: {
      containerClass: 'bg-yellow-50 text-yellow-900',
      iconClass: 'text-yellow-400',
      Icon: AlertTriangle,
    },
    info: {
      containerClass: 'bg-blue-50 text-blue-900',
      iconClass: 'text-blue-400',
      Icon: Info,
    },
  };

  const { containerClass, iconClass, Icon } = variants[variant];

  return (
    <div className={cn('flex items-center gap-2 rounded-md px-4 py-3', containerClass)}>
      <Icon className={cn('h-5 w-5', iconClass)} />
      <p className="text-sm">{message}</p>
    </div>
  );
}
